import { render, staticRenderFns } from "./standard-icon.vue?vue&type=template&id=166d9cf3&scoped=true&"
import script from "./standard-icon.vue?vue&type=script&lang=js&"
export * from "./standard-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166d9cf3",
  null
  
)

export default component.exports